import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.653 9.884h4.231v-4.23h-4.23zM20.116 9.884h4.23v-4.23h-4.23zM5.653 24.347h4.231v-4.228h-4.23zM18.7 23.984v-8.197h5.775V11.82H22.9v2.393h-7.112V12.9h5.306v-1.6h-6.882v2.912H7.1V12.9h5.306v-1.6H5.525v4.487H17.1v8.197"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.019 18.7h8.194v1.288h-2.394v1.6h2.393V22.9H11.82v1.578h3.968V17.1H6.02M22.9 23.981h1.6v-3.475h-1.6z"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.981 17.1h-3.994v6.884h1.6V18.7h2.394M17.1 9.494h1.6V5.525h-6.881V7.1H17.1"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.819 10.013h3.475v-1.6h-3.475zM18.478 3v1.344h7.181v7.178H27V3M3 3v8.522h1.34V4.344h7.182V3M25.66 18.478v7.181h-7.182V27H27v-8.522M3 18.478V27h8.522v-1.34H4.34v-7.182"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }